import { Interaction } from '@ajax/vue/components/templates/item-list/condition/contactlens/interaction/interaction'
import { none, Option, some } from 'fp-ts/lib/Option'

export interface FormValue {
  readonly key: string
  readonly value: string | unknown
}

/**
 * formに設定する値を構築する
 *
 * formというview都合で変更が発生する場合、ここで吸収する想定.
 * たとえば、formの構造や実装を変更によって、interactionの結果に変換が発生する場合など.
 *
 * そもそもformというview構造を取らなくなる場合、この関数は不要になる可能性がある.
 */
export function formValues(
  interaction: Pick<Interaction, 'conditionAsQuery'>,
  query: URLSearchParams
): readonly FormValue[] {
  return [
    ...optionToArray(formValueFromQuery('keywords', query)),
    ...optionToArray(formValueFromQuery('sort', query)),
    ...interaction.conditionAsQuery.keyValues(),
  ]
}
function formValueFromQuery(key: string, query: URLSearchParams): Option<{ key: string; value: string }> {
  const value = query.get(key)

  return value ? some({ key, value }) : none
}
function optionToArray<T>(o: Option<T>): T[] {
  return o.map(v => [v]).getOrElse([])
}
